import { MissingTranslationHandler as NgxMissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

export class MissingTranslationHandler implements NgxMissingTranslationHandler {

    private missing = {};

    handle(params: MissingTranslationHandlerParams) {
        this.missing[params.key] = null;

        // console.log('Missing translation for', Object.keys(this.missing));

        return params.key;
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/localization/missing-translation-handler.ts